import React, { useState } from "react";
import Banner from "../components/Banner";
import AboutUsSec from "../sections/aboutus/AboutUsSec";
import AOS from "aos"; // Import AOS library
import OurPartnersSec from "../sections/homepage/OurPartnersSec";

import { fetchAPI } from "../helper/fetchAPI";
import * as constants from "../constants";
import News from "../components/News";
import CustomHelmet from "../components/CustomHelmet";
import { t } from "i18next";
import FullScreenLoader from "../components/FullScreenLoader";
import { useTranslation } from "react-i18next";
import { useCountryPrefix } from "../routes/useCountryPrefix";

const AboutUs = () => {
  let apiUrl = process.env.REACT_APP_API_URL;
  const { i18n } = useTranslation();
  const countryPrefix = useCountryPrefix();

  const [ourPartnersSection, setOurPartnersSection] = useState();
  const [ourNewsSection, setOurNewsSection] = useState();
  const [isLoaded, setIsLoaded] = useState(false);

  const fetchData = async () => {

    try {
      const isArabic = i18n.language === "ar";
      const language = isArabic ? "ar" : "en";
      apiUrl = `${apiUrl}${constants.homepage}?language=${language}&region_id=${countryPrefix}`;
      const res = await fetchAPI(apiUrl, "Get");
      if (res?.status === 200) {
        const section = res.data.sections;
        setOurPartnersSection(section.find((item) => item.sectionId === "PartnerSection"));
        setOurNewsSection(section.find((item) => item.sectionId === "NewsSection"));
        setIsLoaded(true)
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  React.useEffect(() => {
    AOS.init();

    fetchData();
  }, []);

  if (!isLoaded) {
    return (
      <FullScreenLoader />
    )
  }

  return (
    <>
      <CustomHelmet
        title={"Exclusive Real Estate Across Egypt"}
        desc={'Connect Homes makes exploring real estate in Egypt simple and seamless.'} />
      <Banner
        title={t("about_us")}
        desc={t("banner_desc")}
      ></Banner>
      <AboutUsSec />
      <OurPartnersSec data={ourPartnersSection || {}} />
      <News data={ourNewsSection || {}} />
    </>
  );
};

export default AboutUs;
